export const containNumberRegex = /[0-9]+/;

export const containLowerCaseRegex = /[a-z]+/;

export const containUpperCaseRegex = /[A-Z]+/;

export const containSpecialCharacterRegex = /[!@#$%^&*)(+=._-]+/;
